import { connect } from 'react-redux'
import Assessment from './assessment'
import { fetchAssessmentFiles } from '../../../../stores/assessment/assessment.actions'
import { withRouter } from 'react-router-dom'
import { getFetchRequest } from '../../../../stores/assessment/assessment.selectors'

const mapsStateToProps = state => ({
  pending: getFetchRequest(state).pending
})

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: () => dispatch(fetchAssessmentFiles(match.params.id))
})

export default withRouter(
  connect(
    mapsStateToProps,
    mapDispatchToProps
  )(Assessment)
)
